import type { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { nonEmpty } from "@swo/shared";

export function getReviewScoreFormatter(locale: SwarovskiOptikLocaleFrontend) {
  const locales = [
    locale.country === "INTERNATIONAL" ? undefined : locale.country.isoCode,
    locale.language.isoCode,
    "en",
  ].filter(nonEmpty);

  const config = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  };

  try {
    return new Intl.NumberFormat(locales, config);
  } catch (e) {
    return new Intl.NumberFormat("en", config);
  }
}
